export default "__VITE_ASSET__Cnw48eYl__"